import React from 'react'
import PropTypes from 'prop-types'

import StepIndicator from './StepIndicator'


const ViewHeader = ({
  title,
  description,
}) => {
  return (
    <span className="cls-view-header-container">
      <span className="cls-view-header-info">
        <span className="cls-view-header-text">{title}</span>
        <span className="cls-view-description-text">{description}</span>
      </span>
      <StepIndicator />
    </span>
  )
}

ViewHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default ViewHeader
